import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import 'components/Table/Table.less';

interface TableProps {
    children?: ReactNode;
    fullWidth?: boolean;
    withStripes?: boolean;
    bordered?: boolean;
    withBorderedBottom?: boolean;
    withAllBordered?: boolean;
    className?: string;
}

const Table: FC<TableProps> = ({
    children,
    fullWidth,
    withStripes,
    bordered,
    withBorderedBottom,
    withAllBordered,
    className = '',
    ...props
}) => (
    <table
        className={classNames(
            'table',
            { 'table_full-width': fullWidth },
            { 'table_with-stripes': withStripes },
            { [`table_bordered`]: bordered },
            { 'table_bordered-bottom': withBorderedBottom },
            { [`table_with-all-bordered`]: withAllBordered },
            className
        )}
        {...props}
    >
        {children}
    </table>
);

Table.defaultProps = {
    fullWidth: false,
    withStripes: false,
    bordered: false,
    withBorderedBottom: false,
    withAllBordered: false,
};

export default Table;
